export const AUDIO_ALLOWED_TYPES = ["audio/mpeg", "audio/wav", ".m4a"];

export const AUDIO_MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

export const AUDIO_MIN_DURATION = 10; // 10秒

export const AUDIO_MAX_DURATION = 120; // 120秒
